/** Placeholder shown while the due list loads (first visit or after the RFP filter changes), shaped like the stage strip and a stage panel. */
export default function DueSkeleton() {
  return (
    <div className="space-y-6 animate-pulse" role="status" aria-label="Loading the due list">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {[0, 1, 2, 3, 4].map((i) => <div key={i} className="h-20 rounded-xl bg-surface-muted border border-border" />)}
      </div>
      <div className="rounded-xl border border-border bg-surface overflow-hidden">
        <div className="px-4 py-3 border-b border-border bg-surface-muted space-y-2">
          <div className="h-4 w-48 rounded bg-border" />
          <div className="h-3 w-72 max-w-full rounded bg-border" />
        </div>
        <div className="p-3 space-y-3">
          {[0, 1, 2].map((i) => <div key={i} className="h-24 rounded-lg bg-surface-muted border border-border" />)}
        </div>
      </div>
    </div>
  );
}
